import { HypeIcon } from "@ob/core";
import { ThemeOptions } from "@mui/material";

const radioSize = 18;
export const muiRadio: ThemeOptions["components"] = {
  MuiRadio: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          "&.Mui-checked": {
            color: theme.palette.checkbox.default,
          },
          "&.Mui-disabled": {
            color: theme.palette.text.disabled,
          },
        };
      },
    },
    defaultProps: {
      icon: (
        <HypeIcon
          name="icon_check_no"
          size={radioSize}
          aria-label="unchecked"
        />
      ),
      checkedIcon: (
        <HypeIcon name="icon_check_ok" size={radioSize} aria-label="checked" />
      ),
    },
  },
};
